export const GA4_MEASUREMENT_ID = 'G-PJT42R0RB4';
export const GOOGLE_ADS_CONVERSION_ID = 'AW-1069283117';

export enum ConversionLabels {
    AccountRegistration = 'rh_dCMm4_ewcEK3u7_0D',
    BidPlaced = 'ffLWCKjnie0cEK3u7_0D',
    FollowedSearch = 'k9knCIOdzu0cEK3u7_0D',
    SavedItem = 'XrwOCLrb0e0cEK3u7_0D',
}

type TrackConversionParams = {
    currency?: string;
    label: ConversionLabels;
    transactionId?: string;
    value?: number;
};

export const GOOGLE_TAG_CONFIG_SCRIPT_SRC = '/public-assets/js/google-tag.v1.js';

export const script = () => (
    <>
        <script
            async
            key="googleTagLoader"
            src={`https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`}
        />
        <script
            data-ads-id={GOOGLE_ADS_CONVERSION_ID}
            data-ga4-id={GA4_MEASUREMENT_ID}
            key="googleTagConfig"
            src={GOOGLE_TAG_CONFIG_SCRIPT_SRC}
        />
    </>
);

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
    }
}

export const trackConversion = ({ currency, label, transactionId, value }: TrackConversionParams) => {
    const payload = {
        ...(currency !== undefined && { currency }),
        send_to: `${GOOGLE_ADS_CONVERSION_ID}/${label}`,
        ...(transactionId !== undefined && { transaction_id: transactionId }),
        ...(value !== undefined && { value }),
    };

    if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', payload);
    }
};
